import clarity from '@microsoft/clarity';

/**
 * Initialize Microsoft Clarity analytics
 * Only runs in production builds to avoid tracking during development
 */
export function initClarity() {
  if (import.meta.env.PROD) {
    clarity.init('u3cl4k0cfq');
  }
}
